import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=4a3422d9&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"
import style0 from "./Location.vue?vue&type=style&index=0&id=4a3422d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3422d9",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QTabs,QTab,QTabPanels,QTabPanel,QTable,QBtn,QTr,QTh,QTd,QDialog,QCardSection,QInput,QToggle,QCardActions,QSelect,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QTabs,QTab,QTabPanels,QTabPanel,QTable,QBtn,QTr,QTh,QTd,QDialog,QCardSection,QInput,QToggle,QCardActions,QSelect,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
